
$(document).ready(function () {


  let AD = {
    pc: true
  };



  const mediaQuery = window.matchMedia("(min-width: 1025px)");
  function handleScreenChange(e) {
    // console.log(e.matches);
    AD.pc = e.matches;
    return e.matches
  }
  mediaQuery.addListener(handleScreenChange);
  handleScreenChange(mediaQuery);



  // 懒加载
  var lazyLoadInstance = new LazyLoad({});

  var recommend_swiper = new Swiper("#recommend_swiper", {
    autoHeight: true,
    loop: true,
    slidesPerView:2,
    spaceBetween:10,
    slidesPerGroup:2,
    centeredSlides: false,
    lazy: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".recommend-list .swiper-button-next",
      prevEl: ".recommend-list .swiper-button-prev",
    },
    breakpoints: {
      1025: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup:  4,
      }
    },
  });


  var honour_swiper1 = new Swiper("#honour_swiper1", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    lazy: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
      }
    },
  });


  var honour_swiper2 = new Swiper("#honour_swiper2", {
    autoHeight: true, //高度随内容变化
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    lazy: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,

      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: false,

      }
    },
  });

  var honour_swiper3 = new Swiper("#honour_swiper3", {
    autoHeight: true, //高度随内容变化
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    slidesPerGroup: 1,
    loopFillGroupWithBlank: true,
    lazy: true,
    autoplay: {
      delay: 5000, //n秒切换一次
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,
        slidesPerGroup: 2,
      },
      1025: {
        slidesPerView:  4,
        spaceBetween: 30,
        loop: false,
        slidesPerGroup:4,
      }

     }
  });

  var mySwiper_blogs = new Swiper("#mySwiper_blogs", {
    autoHeight: true,
    // updateOnImagesReady: true,
    // lazy: {
    //   loadPrevNext: true,
    // },
    lazy: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 40,
        slidesPerGroup: 1,
      }
     }
  });

  var influencer_swiper = new Swiper(".influencer-swiper", {
    loop: true,
    loopAdditionalSlides: 0,
    lazy:true,
    spaceBetween: 15,
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: false,
    noSwiping: true,
    navigation: {
      nextEl: ".ANDA_INFLUENCER .swiper-button-next",
      prevEl: ".ANDA_INFLUENCER .swiper-button-prev",
    },
    on:{
      slideChangeTransitionEnd: function(el){

        // if(!AD.pc){return}
        let pre = $('.influencer-swiper .swiper-slide-prev').html()
        $('.influencer-copy').html(pre)

      },

    },

    breakpoints: {
      1025: {
        slidesPerView: 2,
        spaceBetween: 15,
        centeredSlides: false,
        centeredSlidesBounds: false,
        noSwiping: false,
      }
     }
  });

  //  移动端展开导航
  $(".isMobile_nav_icon").click(function () {
    $(".ad_nav,body").toggleClass("active");
    $(this).toggleClass("active");
    $(".one_link").removeClass("active").siblings(".subMenu").hide();
  });


  $(".empty_body").click(function () {
    $(this).toggleClass("active");
    $(".ad_topnav_icon .btn_icon").removeClass("active");
    $(".ad_topnav_icon_xiala").hide();
  });

  $(".cart_icon,.guojia_icon").click(async function () {
    $("#cart_ajax").animate({ scrollTop: 0 }, 100);
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      $(".empty_body").addClass("active");
      $(this).siblings().removeClass("active");
      $(this).find(".ad_topnav_icon_xiala").show();
      //判断是否购物车的下拉，是的话请求购物车数据渲染
      if ($(this).hasClass("cart_icon")) {
        // ajaxCartData();
      }
    } else {
      $(this).find(".ad_topnav_icon_xiala").hide();
      $(".empty_body").removeClass("active");
    }
    $(this).siblings().find(".ad_topnav_icon_xiala").hide();
  });
  $(".ad_topnav_icon_xiala").click(function (event) {
    event.stopPropagation();
  });


  //移动端底部footer
  $(".footer_item .footer_item_a").click(function (event) {
    if (!AD.pc) {
      console.log("mobile");
      event.preventDefault();
      $(this).toggleClass("active").siblings(".mobile_box_f").slideToggle(600);
      $(this).parent().siblings().find(".footer_item_a").removeClass("active");
      $(this).parent().siblings().find(".mobile_box_f").hide();
    }
  });


  return;

  // 导航产品系列数据
  var vm = new Vue({
    el: "#root",
    data: {
      SeriesIndex: 0,
      productNavSwiper: [],
      productList: [
        {
          SeriesName: "Phantom 1 Series",
          SeriesId: 0,
          list: [
            {
              id: 1,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "/index.html",
            },
            {
              id: 2,
              imgUrl: "./images/tp_2.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 3,
              imgUrl: "./images/tp_3.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 4,
              imgUrl: "./images/tp_4.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 1,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "/index.html",
            },
            {
              id: 2,
              imgUrl: "./images/tp_2.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 3,
              imgUrl: "./images/tp_3.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 4,
              imgUrl: "./images/tp_4.png",
              product: "Ash Gray",
              link: "",
            },
          ],
        },
        {
          SeriesName: "Phantom 2 Series",
          SeriesId: 1,
          list: [
            {
              id: 1,
              imgUrl: "./images/tp_4.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 2,
              imgUrl: "./images/tp_3.png",
              product: "Ash Gray",
              link: "",
            },
          ],
        },
        {
          SeriesName: "Phantom 3 Series",
          SeriesId: 3,
          list: [
            {
              id: 1,
              imgUrl: "./images/tp_3.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 2,
              imgUrl: "./images/tp_4.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 3,
              imgUrl: "./images/tp_2.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 4,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 5,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 6,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "",
            },
          ],
        },
        {
          SeriesName: "Phantom 4 Series",
          SeriesId: 4,
          list: [
            {
              id: 1,
              imgUrl: "./images/tp_3.png",
              product: "Ash Gray",
              link: "",
            },
            {
              id: 2,
              imgUrl: "./images/tp_1.png",
              product: "Ash Gray",
              link: "",
            },
          ],
        },
      ],
    },
    created: function () {},
    mounted: function () {
      this.initNav();
      //包在vue里的要写在Vue里面才生效
      if (AD.pc) {
        $(".ad_nav ul li").hover(function () {
          $(this).children("div.subMenu").stop().slideToggle(600);
          $(".ad_nav").css("position", "static");

        });
        $(".ad_nav").hover(
          function () {
            // $(".top_search_select_list").css("display", "flex");
          },
          function () {
            $(".ad_nav").css("position", "relative");
          }
        );
      }

      // 头部搜索框下拉
      $(".top_search_select_list a").click(function () {
        let val = $(this).text();
        $(".top_search_select span").text(val);
        $(".top_search_select_list").hide();
      });
      //   $(".top_search_btn ").click(function () {
      //     $(".top_search").hide();
      //   });
      $(".bottom_cart .select ").click(function () {
        $(this).toggleClass("active");
      });
      $(".top_search_select").hover(
        function () {
          $(".top_search_select_list").css("display", "flex");
        },
        function () {
          $(".top_search_select_list").hide();
        }
      );
    },
    methods: {
      initNavSwiper() {
        var swiper_navSwiper = new Swiper(".navSwiper", {
          autoHeight: true, //高度随内容变化
          observer: true,
          observeParents: true,
          slidesPerView: 4,
          // loop: true,
          // loopFillGroupWithBlank: true,
          spaceBetween: 20,
          // lazy: {
          //   loadPrevNext: true,
          // },
          //   autoplay: {
          //     delay: 5000, //n秒切换一次
          //   },
        });
        $(".subMenu_main_right_btn .swiper-button-left").click(function () {
          swiper_navSwiper.slidePrev();
        });
        $(".subMenu_main_right_btn .swiper-button-right").click(function () {
          swiper_navSwiper.slideNext();
        });

        var mobile_pro_swiper = new Swiper(".mobile_pro_swiper", {
          autoHeight: true, //高度随内容变化
          slidesPerView: "auto",
          spaceBetween: 10,
          lazy: true,
          // lazy: {
          //   loadPrevNext: true,
          // },
        });
      },
      initNav() {
        this.productNavSwiper = this.productList[0].list;
        this.initNavSwiper();
      },
      change_Series(id) {
        this.SeriesIndex = id;
        this.productNavSwiper = this.productList[id].list;
        this.initNavSwiper();
      },
    },
    computed: {},
    watch: {},
  });


  //dialog
  var root = new Vue({
    el: "#dialog",
    data: {
      title: "Login",
    },
    created: function () {},
    mounted: function () {
      $(".one_link").click(function (event) {
        if (!AD.pc) {
          if (!$(this).hasClass("golink")) {
            event.preventDefault(); // 如果是移动端
          }
          $(this).toggleClass("active").siblings(".subMenu").slideToggle(600);
          $(this).parent().siblings().find(".one_link").removeClass("active");
          $(this).parent().siblings().find(".subMenu").hide();
        }
      });
    },
    methods: {
      fromBtn(val) {
        console.log(val);
        if (val === "Create your account") {
          this.title = "Register";
        } else if (val === "Forgot your password?") {
          this.title = "Reset Your Password";
        } else if (val === "Sign In") {
        } else if (val === "Register") {
        } else if (val === "Reset Password") {
        } else if (val === "Login here" || val === "Cancel") {
          this.title = "Login";
        }
      },
      close_btn() {
        $("#dialog").hide();
      },
    },
    computed: {},
    watch: {},
  });


  //购物车
  var Vuecart = new Vue({
    el: "#cart_ajax",
    data: {
      totalNum: 0,
      cart: [
        // {
        //   imgurl: "./images/20220822index25.png",
        //   product: " Phantom 3 Series Premium Office Gaming Chair ",
        //   sku: "Premium PVC Leather",
        //   color: "Elegant Black",
        //   size: "L",
        //   total: 1,
        //   price: "10",
        //   url: "https://www.andaseat.com/",
        // },
        // {
        //   imgurl: "./images/20220822index25.png",
        //   product: " Phantom 3 Series Premium Office Gaming Chair ",
        //   sku: "Premium PVC Leather",
        //   color: "Elegant Black",
        //   size: "L",
        //   total: 2,
        //   price: "20",
        //   url: "https://www.andaseat.com/",
        // },
        // {
        //   imgurl: "./images/20220822index25.png",
        //   product: " Phantom 3 Series Premium Office Gaming Chair ",
        //   sku: "Premium PVC Leather",
        //   color: "Elegant Black",
        //   size: "L",
        //   total: 3,
        //   price: "30",
        //   url: "https://www.andaseat.com/",
        // },
        // {
        //   imgurl: "./images/20220822index25.png",
        //   product: " Phantom 3 Series Premium Office Gaming Chair ",
        //   sku: "Premium PVC Leather",
        //   color: "Elegant Black",
        //   size: "L",
        //   total: 4,
        //   price: "40",
        //   url: "https://www.andaseat.com/",
        // },
        // {
        //   imgurl: "./images/20220822index25.png",
        //   product: " Phantom 3 Series Premium Office Gaming Chair ",
        //   sku: "Premium PVC Leather",
        //   color: "Elegant Black",
        //   size: "L",
        //   total: 5,
        //   price: "50",
        //   url: "https://www.andaseat.com/",
        // },
      ],
    },
    created: function () {},
    mounted: function () {
      this.calcTotalNum();
      //进入页面第一次加载购物车
      // ajaxCartData();
    },
    methods: {
      productLink(url) {
        window.location = url;
      },
      calcTotalNum() {
        // console.log(this.cart);
        if (this.cart.length) {
          let num = 0,
            totalPrice = 0;
          this.cart.forEach((i) => {
            num += i.total;
            totalPrice += i.total * i.price;
          });
          this.totalNum = num;
          $(".cart_icon .total_span").text(this.totalNum).show();
          $(".ad_topnav_icon_xiala_list").removeClass("cartIsEmpty");
          $(".bottom_cart_header span").text("$" + totalPrice.toFixed(2));
          //更新RECOMMEND PRODUCTS  swiper的购物车角标,要先把所有的清空在更新
          $(".product_btn .carticon").html("");
          this.cart.forEach((i) => {
            $(`.cart_productId_${i.productId}`).html(`<span>${i.total}</span>`);
          });
        } else {
          $(".cart_icon .total_span").text("").hide();
          $(".ad_topnav_icon_xiala_list").addClass("cartIsEmpty");
          $(".bottom_cart_header span").text("");
          //清空RECOMMEND PRODUCTS  swiper的购物车角标
          $(".product_btn .carticon").html("");
        }
      },
      change_info(item) {
        return `${item.sku} / ${item.size} / ${item.color}`;
      },
      InputSearch(index, e) {
        if (e.target.value == "0" || !e.target.value) {
          this.cart[index].total = 1;
        } else {
          let num = parseInt(e.target.value);
          this.cart[index].total = num;
        }
        this.calcTotalNum();
      },
      minus(index, num) {
        if (num != 1) {
          this.cart[index].total--;
          this.calcTotalNum();
        }
      },
      add(index, num) {
        this.cart[index].total++;
        this.calcTotalNum();
      },
      del(index) {
        this.cart.splice(index, 1);
        this.calcTotalNum();
      },
    },
    computed: {},
    watch: {},
  });


  //对比
  var Compare = new Vue({
    el: "#duibi_box",
    data: {
      list: [
        // {
        //   productId:'1',
        //   imgurl:'../images/20220822index2599.png',
        //   link:''
        // },
        // {
        //   productId:'222',
        //   imgurl:'../images/20220822index25.png',
        //   link:''
        // },
        // {
        //   productId:'13333',
        //   imgurl:'../images/tp_1.png',
        //   link:''
        // },
      ],
    },
    mounted: function () {},
    methods: {
      clearData() {
        this.list = [];
        $(".product_btn .duibi").html("");
        $(".actGotop,.footer_contact").removeClass("isMobileShow");
      },
      delCompareId(index) {
        this.list.splice(index, 1);
        console.log("delCompareId---this.list", this.list);
        // 先清空在重新赋值
        $(".product_btn .duibi").html("");
        if (this.list && this.list.length) {
          this.list.forEach((item, index) => {
            $(`.duibi_productId_${item.productId}`).html(
              `<span>${index + 1}</span>`
            );
          });
        } else {
          $(".actGotop,.footer_contact").removeClass("isMobileShow");
        }
      },
      removeClassisDownScroll() {
        $("#duibi_box").removeClass("isDownScroll");
      },
    },
    computed: {
      listSize() {
        if (this.list.length) {
          $(".actGotop,.footer_contact").addClass("isMobileShow");
        }
        return this.list.length;
      },
    },
  });



  //产品列表喜欢按钮
  let xihuan_num = [];
  $(".product_btn .xihuan").click(function (event) {
    $(this).toggleClass("active");
    let id = $(this).attr("data-xihuan");
    if ($(this).hasClass("active")) {
      $(`.xihuan_${id}`).addClass("active");
      xihuan_numFn(xihuan_num, id, "add");
    } else {
      $(`.xihuan_${id}`).removeClass("active");
      xihuan_numFn(xihuan_num, id, "minus");
    }
  });
  function xihuan_numFn(arr, id, action) {
    if (action === "add") {
      xihuan_num.push(id);
    } else {
      let index = arr.indexOf(id);
      xihuan_num.splice(index, 1);
    }
    if (xihuan_num.length) {
      $(".xihuan_icon .total_span").text(xihuan_num.length).show();
    } else {
      $(".xihuan_icon .total_span").text("").hide();
    }
  }



  //ajax购物车
  async function ajaxCartData() {

    let carturl = "./mock/cart.json",
      cartInfo = [];
    var cartContents = await fetch(carturl)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    if (cartContents.item_count && cartContents.items) {
      cartContents.items.forEach((i) => {
        cartInfo.push({
          imgurl: i.image,
          product: i.product_title,
          variant_title: i.variant_title,
          url: i.url,
          total: i.quantity,
          price: i.price,
          productId: i.id,
        });
      });
      // windowCart = cartInfo;
      Vuecart.cart = cartInfo;
      Vuecart.calcTotalNum();
      cartInfo.forEach((i) => {
        // console.log(i.productId);
        //列表购物车
        $(`.cart_productId_${i.productId}`).html(`<span>${i.total}</span>`);
      });
    }
  }



  //产品列表对比
  $(".product_btn .duibi").click(function () {

    let compareId = $(this).attr("data-compare"),
      listNum = Compare.list.length;
    if (listNum == 4 && !$(this).hasClass("active")) return;
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      if (listNum < 4) {
        Compare.list.push({
          productId: compareId,
          imgurl: "../images/tp_4.png",
          link: "",
        });
        $(`.duibi_productId_${compareId}`).html(
          `<span>${Compare.list.length}</span>`
        );
      }
      // console.log("Compare.list----11", Compare.list);
    } else {
      // console.log("Compare.list----22", Compare.list);
      let numText = $(this).find("span").text();
      Compare.delCompareId(Number(numText) - 1);
    }
  });
});
